import React from 'react';

const Logout = () => (
  <div className="flex justify-center font-americaMonoRegular">
    <div className="mt-8">YOU ARE LOGGED OUT!</div>
  </div>
);

export default Logout;
